import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from '../styles/colors';

const LabelText = styled.span`
  font-size: 16px;
`;

const Container = styled.div`
  margin-bottom: 8px;
  color: ${colors.GRAY_DARKEST};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  
  ${({ meta }) => meta && meta.touched && meta.error ? css`
  color: ${colors.DANGER};
  ` : ''}
  }
`;


const Label = ({
  children,
  weight,
  isRequired,
  ...props
}) => (
  <Container
    isRequired={isRequired}
    {...props}
  >
    <LabelText weight={weight}>
      {children}
    </LabelText>
  </Container>
);

export default Label;
